import { solidstate } from ":setup/qstate";
import type { ARequestProps } from "./_model";

export const $confirm_dialogs = solidstate.create<ARequestProps[]>([]);
export const actions = {
  pushConfirmDialog(props: ARequestProps) {
    $confirm_dialogs.set((s) => [...s, props]);
  },
};
